import { createTheme } from "@mui/material/styles";
import { red } from "@mui/material/colors";

// Create a theme instance.
const tiscoTheme = createTheme({
  palette: {
    background: {
      default: "#FFFAFA",
    },
    primary: {
      main: "#333333",
      light: "#CCCCCC",
      dark: "#000000",
    },
    secondary: {
      main: "#6F7072",
      light: "#B0B2B3",
      dark: "#656565",
    },
    error: {
      main: red.A400,
    },
  },
  typography: {
    fontSize: 12,
    h1: {
      color: "#333333",
      fontSize: 32,
      fontWeight: "bold",
    },
    h2: {
      color: "#333333",
      fontSize: 28,
      fontWeight: "normal",
    },
    h3: {
      color: "#000000",
      fontSize: 24,
      fontWeight: "normal",
    },
    h4: {
      color: "#000000",
      fontSize: 18,
      fontWeight: "normal",
    },
    body1: {
      color: "#000000",
    },
    body2: {
      color: "#000000",
      fontSize: 14,
    },
    caption: {
      color: "#BABABA",
      fontSize: 11,
    },
  },
  components: {
    MuiPaper: {
      defaultProps: {
        sx: {
          backgroundColor: "#FFFFFF",
        },
      },
    },
  },
});

export default tiscoTheme;
